module.exports = __webpack_public_path__ + "img/icon_sb_white_glove_boutique_16x16.c2cda85.svg";